import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\FuneralHomePartner\Elys\ElysGetCemeteryReservationController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Elys/ElysGetCemeteryReservationController.php
* @route '/api/company/{company}/elys/dossier/{dossier_id}/cemetery-reservation'
*/
const ElysGetCemeteryReservationController = (args: { company: string | number | { id: string | number }, dossier_id: string | number } | [company: string | number | { id: string | number }, dossier_id: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ElysGetCemeteryReservationController.url(args, options),
    method: 'get',
})

ElysGetCemeteryReservationController.definition = {
    methods: ["get","head"],
    url: '/api/company/{company}/elys/dossier/{dossier_id}/cemetery-reservation',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\FuneralHomePartner\Elys\ElysGetCemeteryReservationController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Elys/ElysGetCemeteryReservationController.php
* @route '/api/company/{company}/elys/dossier/{dossier_id}/cemetery-reservation'
*/
ElysGetCemeteryReservationController.url = (args: { company: string | number | { id: string | number }, dossier_id: string | number } | [company: string | number | { id: string | number }, dossier_id: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            company: args[0],
            dossier_id: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
        dossier_id: args.dossier_id,
    }

    return ElysGetCemeteryReservationController.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace('{dossier_id}', parsedArgs.dossier_id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\FuneralHomePartner\Elys\ElysGetCemeteryReservationController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Elys/ElysGetCemeteryReservationController.php
* @route '/api/company/{company}/elys/dossier/{dossier_id}/cemetery-reservation'
*/
ElysGetCemeteryReservationController.get = (args: { company: string | number | { id: string | number }, dossier_id: string | number } | [company: string | number | { id: string | number }, dossier_id: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ElysGetCemeteryReservationController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\FuneralHomePartner\Elys\ElysGetCemeteryReservationController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Elys/ElysGetCemeteryReservationController.php
* @route '/api/company/{company}/elys/dossier/{dossier_id}/cemetery-reservation'
*/
ElysGetCemeteryReservationController.head = (args: { company: string | number | { id: string | number }, dossier_id: string | number } | [company: string | number | { id: string | number }, dossier_id: string | number ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: ElysGetCemeteryReservationController.url(args, options),
    method: 'head',
})

export default ElysGetCemeteryReservationController